import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../../shared/store/selected-entity.feature';
import { Étape } from '../../models/étape.model';
import { avecMéthodesEtapes } from './etape.methods';
import { avecSélecteursÉtapes } from './etape.selectors';

export const EtapeStore = signalStore(
  { providedIn: 'root' },
  withEntities<Étape>(),
  withSelectedEntity(),
  avecMéthodesEtapes(),
  avecSélecteursÉtapes(),
);
